import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getDashboardNotificationList = createAsyncThunk(
  "dashboardNotificationList/getDashboardNotificationList",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/notification/get_all_dashboard_notification`,
        data,

        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const dashboardNotificationSlice = createSlice({
  name: "dashboardNotificationList",
  initialState: {
    loading: false,
    dashboardNotificationData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDashboardNotificationList.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getDashboardNotificationList.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardNotificationData = action.payload;
      })
      .addCase(getDashboardNotificationList.rejected, (state, action) => {
        state.loading = false;
        state.dashboardNotificationData = action.payload;
        state.error = action.payload;
      });
  },
});

export default dashboardNotificationSlice.reducer;
